<template>
  <!-- Corpo -->
  <div class="bg-white rounded-lg shadow-md p-6 mb-4">
    <div class="flex justify-center">
      <img :src="`/images/icons/reception-digitale/loghi-aziendali/`+$page.props.customer?.slug+`/loghi.png`" class="h-20">
    </div>
  </div>
  
  <div class="bg-white rounded-lg shadow-md p-6 mb-4">
    <Transition name="fade" mode="out-in">
      <h1 v-if="!requestTakenInCharge" key="waiting" class="text-center text-2xl font-bold mb-4">
        Il referente è stato avvisato della richiesta di firma.
      </h1>
      <h1 v-else key="arriving" class="text-center text-2xl font-bold mb-4">
        Il referente sta arrivando per porre la firma!
      </h1>
    </Transition>
    
    <Transition name="slide-fade" mode="out-in">
      <div v-if="!requestTakenInCharge" key="waiting-content" class="text-center">
        <p class="text-xl mb-4">
          Attendere prego.
        </p>
        <div class="inline-flex items-center justify-center">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
          <span class="ml-3 text-gray-600">In attesa...</span>
        </div>
      </div>
      <div v-else key="arriving-content" class="text-center">
        <p class="text-xl mb-4">
          Attendilo qui alla reception, arriverà a breve.
        </p>
        <div class="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4">
          <svg class="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
          </svg>
        </div>
        <p class="text-sm text-gray-600">Il referente è in arrivo!</p>
      </div>
    </Transition>
  </div>

  <div
    style="position: fixed; bottom: 20px; right: 20px; width: 60px; height: 60px; z-index: 50; cursor: pointer; opacity: 0.1; border: 2px solid #888; border-radius: 12px;"
    @click="easterEggConfirmCourier"
  ></div>
</template>

<script>
import { router } from '@inertiajs/vue3';
import LayoutNoHeader from '@/Layouts/LayoutNoHeader.vue';
import axios from 'axios';

export default {
  layout: LayoutNoHeader,
  props: ['courierDelivery'],
  data() {
    return {
      pollingInterval: null,
      requestTakenInCharge: false
    };
  },
  mounted() {
    this.pollingInterval = setInterval(() => {
      this.checkStatus();
    }, 5000);
  },
  beforeUnmount() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  },
  methods: {
    async checkStatus() {
      try {
        const response = await axios.get(route('modules.rd-dettagli-consegna-corriere', { courierDelivery: this.courierDelivery }));

        if (response.data.confirmed && response.data.confirmed === true) {
          this.requestTakenInCharge = true;
          
          clearInterval(this.pollingInterval);
          
          setTimeout(() => {
            router.visit(route('modules.home', { slug: 'reception-digitale' }));
          }, 20000);
        }
      } catch (error) {
        console.error('Error checking request status:', error);
      }
    },
    async easterEggConfirmCourier() {
      try {
        await axios.get(route('modules.rd-signature-confirm', { courierDelivery: this.courierDelivery }));
        router.visit(route('modules.home', { slug: 'reception-digitale' }));
      } catch (error) {
      }
    }
  }
};
</script>
